import { Component } from '@angular/core';

@Component({
  selector: 'uni-pagination-nav',
  templateUrl: './uni-pagination-nav.component.html',
  styleUrls: ['./uni-pagination-nav.component.scss']
})
export class UniPaginationNavComponent {}
